<template>
  <div class="customer">

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Πληρωμές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>


    <v-data-table
      :headers="headers"
      :items="debits"
      :search="search"
      loading: false
      item-key="DocNumber"
      sort-by="Date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>



    </v-data-table>
  </v-card>
</template>


  </div>
</template>

<script>

export default {
  data() {
    return {
      balance: {charges: 0, payments: 0},
      expanded: [],
      loading: true,
      search: '',
      customer: {},
      customer_id: this.$route.params.id,
      debits: [],
      headers: [
          {
            text: 'Αρ. Πληρωμής',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '10%',
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
          { text: 'Τύπος', value: 'PaymTerm.Desc', align: 'center' },
          { text: 'Remarks', value: 'Remarks', align: 'center' },
          { text: 'Actions', value: 'actions', align: 'end' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/customers/'+this.$route.params.id,
        {
        params: {
            'non-billing': true
            }
        });
        //console.log(response);
        this.customer = response.data; // this.$store.customer;
        this.debits = this.customer.Debits;
        this.balance = this.customer.Balance;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  }

  }
}
</script>
